export const BRAND_NAME = "Eco Tour Turismo";

export const BRAND_FULL_NAME = "Eco Tour Turismo Capitólio";

export const SITE_URL = "https://ecotourturismo.com.br/";

export const OG_IMAGE =
  "https://static.readdy.ai/image/5a7bf947e7865fcd0423f5d91cb65f0c/3a568d363ad4fe6cbe485ed9bae130d4.jpeg";

export const GEO_LAT = -20.6556453;

export const GEO_LNG = -46.2144543;

export const LOGO_URL =
  "https://public.readdy.ai/ai/img_res/87d910b9-21eb-4eb3-bb67-900dbc40792d.png";

export const BRAND_TAGLINE = "Passeios de Lancha em Capitólio";

export const WHATSAPP_NUMBER = "+55 31 99535-5290";

export const WHATSAPP_LINK =
  "https://wa.me/5531995355290?text=Ol%C3%A1%21%20Estou%20no%20site%20da%20Eco%20Tour%20Turismo%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20passeios%20de%20lancha%20em%20Capit%C3%B3lio.";

export const PHONE_DISPLAY = "(31) 99535-5290";

export const PHONE_TEL = "+5531995355290";

export const EMAIL = "receptivo@ecotourturismo.com.br";

export const WEBSITE_DISPLAY = "ecotourturismo.com.br";

export const WEBSITE_LINK = "https://ecotourturismo.com.br";

export const ADDRESS =
  "MG-050, km 305 – 5 — Capitólio/MG — CEP 37930-000, Brasil";

export const BUSINESS_HOURS = "Saídas diárias — consulte os horários";

export const INSTAGRAM_HANDLE = "@ecotour_capitolio";

export const INSTAGRAM_LINK = "https://instagram.com/ecotour_capitolio";

export const GOOGLE_MAPS_LINK =
  "https://www.google.com/maps/search/?api=1&query=Eco%20Tour%20Turismo%20Capit%C3%B3lio%20MG";

export const GOOGLE_REVIEWS_LINK =
  "https://www.google.com/maps/place/Eco+Tour+Turismo+Capitolio/@-20.6556453,-46.2170292,17z/data=!4m8!3m7!1s0x94b6a14df4125093:0xed8bcd72c71d4dc2!8m2!3d-20.6556453!4d-46.2144543!9m1!1b1!16s%2Fg%2F11y5jh5zmr"
;

export const GOOGLE_PLACE_LINK =
  "https://www.google.com/maps/place/Eco+Tour+Turismo+Capitolio/@-20.6556453,-46.2144543,17z";

export const TRIPADVISOR_LINK =
  "https://www.tripadvisor.com.br/Attraction_Review-g1773682-d21396306-Reviews-Eco_Tour_Turismo_Passeios_Nauticos-Capitolio_State_of_Minas_Gerais.html";

export const BOARDING_POINT_NAME = "Complexo Furnas Aventura";

export const BOARDING_MAP_LINK =
  "https://www.google.com/maps/search/?api=1&query=Eco%20Tour%20Turismo%20Capit%C3%B3lio%20MG";

export const BOARDING_MAP_EMBED =
  "https://www.google.com/maps?q=Eco+Tour+Turismo+Capit%C3%B3lio+MG&output=embed";